import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Routes,
  Route,
  Navigate,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./styles/App.css";
import "./index.css";
import CaptacaoDiarias from "./components/Captacao/CaptacaoDiarias";
import ControleDeCaptacao from "./components/Captacao/ControleDeCaptacao";
import AvaliacaoRelatorios from "./components/Avaliacao/AvaliacaoRelatorios";
import AvaliacaoResultados from "./components/Avaliacao/AvaliacaoResultados";
import JuridicoForm from "./components/Juridico/JuridicoForm";
import JuridicoResultados from "./components/Juridico/JuridicoResultados";
import HomeCaptacao from "./components/Captacao/HomeCaptacao";
import Login from "./components/Login/Login";
import Cadastro from "./components/Login/Cadastro";
import Context from "./Context/Context";
import { FaHome } from "react-icons/fa";
import { AiTwotoneFileText } from "react-icons/ai";
import { BsClipboard2DataFill } from "react-icons/bs";
import { RiAuctionLine } from "react-icons/ri";
import { TbBusinessplan } from "react-icons/tb";
import { AiFillControl } from "react-icons/ai";
import { MdOutlineNewLabel } from "react-icons/md";
import { MdNewLabel } from "react-icons/md";
import { GoGitPullRequest } from "react-icons/go";
import { IoIosCreate } from "react-icons/io";
import { AiOutlineFileWord } from "react-icons/ai";
import { GoGoal } from "react-icons/go";
import { HiDocumentText } from "react-icons/hi2";
import { LuUserRoundPlus } from "react-icons/lu";
import { IoEyeSharp } from "react-icons/io5";
import { AiOutlineBarChart } from "react-icons/ai";
import { FaExclamationCircle } from "react-icons/fa";
import axios from 'axios';




import {
  CiLogout,
  CiHome,
  CiCalendar,
  CiGrid31,
  CiStickyNote,
  CiRepeat,
} from "react-icons/ci";
import { BsThreeDotsVertical } from "react-icons/bs";
import MetasAdministrador from "./components/Captacao/MetasAdministrador";
import HomeAvaliacao from "./components/Avaliacao/HomeAvaliacao";
import CasosAvaliacao from "./components/Avaliacao/CasosAvaliacao";
import MetasAvaliacao from "./components/Avaliacao/MetasAvaliacao";
import Modal from "react-modal";
import "./styles/modal.css";
import SolicitacoesCaptacaoAvaliacao from "./components/Solicitacao/SolicitacoesCaptacaoAvaliacao";
import SolicitacaoAndamento from "./components/Solicitacao/SolicitacaoAndamento";
import SolicitacaoesCaptacaoAvaliacao from "./components/Solicitacao/SolicitacoesCaptacaoAvaliacao";
import MetasAvaliacaoControle from "./components/Avaliacao/MetasAvaliacaoControle";
import SolicitacaoAndamentoAv from "./components/Solicitacao/SolicitacaoAndamentoAv";
import { FaWpforms } from "react-icons/fa";
import FormularioEditalSP from "./components/Juridico/FormularioEditalSP";

import PeticaoCiencia from "./components/Juridico/peticoes/peticao_ciencia";
import PeticaoCiencia2Leilao from "./components/Juridico/peticoes/peticao_ciencia_2leilao";
import PeticaoCienciaMesmoJuiz from "./components/Juridico/peticoes/peticao_ciencia_mesmoJuiz";
import PeticaoComunicacaoAutosCredores from "./components/Juridico/peticoes/peticao_Comunicação_Autos_Credores_TRT";
import PeticaoComunicacaoAutosCredoresTRF from "./components/Juridico/peticoes/peticao_Comunicação_Autos_Credores_TRF";
import PeticaoJuntadaEdital from './components/Juridico//peticoes/peticao_juntada_edital'
import PeticaoRetificacaoEdital from './components/Juridico/peticoes/peticao_retificacao_edital'
import PeticaoComprovacao from './components/Juridico/peticoes/peticao_comprovacao'
import EditalJuridico from "./components/Juridico/EditalJuridico";


const App = () => {
  const location = useLocation();
  const { usuario, setUsuario } = useContext(Context);
  const navigate = useNavigate();
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const menuRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const { formData, setFormData } = useContext(Context);
  const [novaFoto, setNovaFoto] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (novaFoto) {
      const objectUrl = URL.createObjectURL(novaFoto);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [novaFoto]);

  const handleFileChange = (e) => {
    setNovaFoto(e.target.files[0]);
  };

  const atualizarFoto = async () => {
    if (!novaFoto) return;

    const data = new FormData();
    data.append("file", novaFoto);

    try {
      const response = await axios.put(`/user/update/foto/${usuario.id}`, data, {
        headers: {
          Authorization: usuario.token,
          "Content-Type": "multipart/form-data",
        },
      });

      const novaUrl = response.data?.fotoUrl;

      if (novaUrl) {
        setPreview(novaUrl); // atualiza a imagem mostrada com a URL do Cloudinary
        // opcional: atualize o objeto `usuario` com a nova URL
        usuario.usuario_foto = novaUrl;
        localStorage.setItem("usuario", JSON.stringify({ ...usuario, fotoUrl: novaUrl }));
      }
      console.log("minha nova foto: ", novaUrl);

      alert("Foto atualizada com sucesso!");
    } catch (err) {
      console.error("Erro ao atualizar foto:", err);

      alert("Erro ao atualizar foto.");
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleLogout = () => {
    setUsuario(null);
    navigate("/");
    setIsLogoutModalOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuExpanded(!isMenuExpanded);
  };

  if (!usuario?.nome) {
    return <Login />;
  }

  const openLogoutModal = () => {
    setIsLogoutModalOpen(true);
  };

  const closeLogoutModal = () => {
    setIsLogoutModalOpen(false);
  };

  const allowed = (role) => {
    return usuario.role.includes(role) || usuario.role.includes("Supervisor");
  };
  console.log(usuario);


  return (
    <div className="flex h-screen bg-gray-100">
      <aside
        className={`transition-all duration-300 bg-black text-white h-full shadow-lg flex flex-col ${isMenuExpanded ? "w-64" : "w-20"}`}
      >
        <div className="flex items-center justify-center p-4 cursor-pointer" onClick={toggleMenu}>
          <img
            src={`${isMenuExpanded ? "/logo.jpg" : "/logo-colapsed.png"}`}
            alt="Logo"
            className="h-10"
          />
        </div>
        <nav className="flex-1 overflow-y-auto">
          <div className="flex flex-col gap-2 p-2">
            <SidebarLink to="/home" label="Home" icon={<FaHome size={24} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/home")} />
            <SidebarLink to="/captacao/home" label="Captação" icon={<TbBusinessplan size={24} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/captacao")} />
            {location.pathname.startsWith("/captacao") && (
              <Submenu expanded={isMenuExpanded}>
                <SidebarLink to="/captacao/diarias" label="Nova Captação" icon={<MdNewLabel size={20} />} expanded={isMenuExpanded} active={location.pathname === "/captacao/diarias"} />
                <SidebarLink to="/captacao/controle" label="Controle de Captação" icon={<AiFillControl size={20} />} expanded={isMenuExpanded} active={location.pathname === "/captacao/controle"} />
                <SidebarLink to="/captacao/solicitacoes" label="Solicitações Internas" icon={<CiStickyNote size={20} />} expanded={isMenuExpanded} active={location.pathname === "/captacao/solicitacoes"} />
                <SidebarLink to="/captacao/solicitacaoAndamento" label="Solicitação Andamento" icon={<GoGitPullRequest size={20} />} expanded={isMenuExpanded} active={location.pathname === "/captacao/solicitacaoAndamento"} />
              </Submenu>
            )}
            <SidebarLink to="/avaliacao/relatorios" label="Avaliação" icon={<BsClipboard2DataFill size={24} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/avaliacao")} />
            {location.pathname.startsWith("/avaliacao") && (
              <Submenu expanded={isMenuExpanded}>
                <SidebarLink to="/avaliacao/relatorios" label="Relatórios" icon={<AiOutlineFileWord size={20} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/avaliacao/relatorios")} />
                <SidebarLink to={usuario.role === "SupervisorNegocios" ? "/avaliacao/metas/controle" : "/avaliacao/metas"} label="Metas" icon={<GoGoal size={20} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/avaliacao/metas")} />
                <SidebarLink to="/avaliacao/solicitacoes" label="Solicitação Andamento" icon={<GoGitPullRequest size={20} />} expanded={isMenuExpanded} active={location.pathname === "/avaliacao/solicitacoes"} />
                <SidebarLink to="/avaliacao/casos" label="Casos Avaliação" icon={<HiDocumentText size={20} />} expanded={isMenuExpanded} active={location.pathname === "/avaliacao/casos"} />
                <SidebarLink to="/avaliacao/solicitacao/form" label="Criar Solicitação" icon={<IoIosCreate size={20} />} expanded={isMenuExpanded} active={location.pathname === "/avaliacao/solicitacao/form"} />
              </Submenu>
            )}
            <SidebarLink to="/juridico/form" label="Jurídico" icon={<RiAuctionLine size={24} />} expanded={isMenuExpanded} active={location.pathname.startsWith("/juridico")} />
            {location.pathname.startsWith("/juridico") && (
              <Submenu expanded={isMenuExpanded}>
                <SidebarLink to="/juridico/edital" label="Gerar Edital" icon={<MdOutlineNewLabel size={20} />} expanded={isMenuExpanded} active={location.pathname === "/juridico/form"} />
              </Submenu>
            )}
            {usuario?.role === "AdministrativoSupervisor" && (
              <SidebarLink to="/cadastro" label="Cadastro" icon={<LuUserRoundPlus size={24} />} expanded={isMenuExpanded} active={location.pathname === "/cadastro"} />
            )}
            {usuario?.role.includes("SupervisorCaptação") && (
              <SidebarLink to="/metas/admin" label="Metas" icon={<AiOutlineBarChart size={24} />} expanded={isMenuExpanded} active={location.pathname === "/metas/admin"} />
            )}
          </div>
        </nav>

        <div className="p-4 cursor-pointer hover:bg-gray-800">
          {isMenuExpanded ? (
            <div className="flex items-center justify-between">
              <div className="flex items-center m-auto gap-2">
                <img
                  src={usuario.usuario_foto || 'https://www.citypng.com/public/uploads/preview/white-user-member-guest-icon-png-image-701751695037005zdurfaim0y.png'}
                  alt="Foto do usuário"
                  className="w-14 h-14 rounded-full"
                />
                <div>
                  <p className="text-sm font-medium">{usuario.nome}</p>
                  <p className="text-xs text-gray-400">{usuario.email}</p>
                </div>


              </div>
              <div
              className="relative flex items-center justify-center"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
              ref={menuRef}
            >
              <BsThreeDotsVertical className="cursor-pointer" />

              {isDropdownOpen && (
                <div
                  className="absolute top-[-10px] left-full ml-[-10px] transform -translate-y-1/2 w-40 bg-white text-black rounded shadow-md z-50"
                >
                  <button
                    onClick={() => setOpen(true)}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Ver perfil
                  </button>
                  <button
                    onClick={openLogoutModal}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Sair
                  </button>
                </div>
              )}
            </div>


            </div>
          ) : (
            <div
              className="relative flex items-center justify-center"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
              ref={menuRef}
            >
              <BsThreeDotsVertical className="cursor-pointer" />

              {isDropdownOpen && (
                <div
                  className="absolute top-[-10px] left-full ml-[-10px] transform -translate-y-1/2 w-40 bg-white text-black rounded shadow-md z-50"
                >
                  <button
                    onClick={() => setOpen(true)}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Ver perfil
                  </button>
                  <button
                    onClick={openLogoutModal}
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                  >
                    Sair
                  </button>
                </div>
              )}
            </div>

          )}
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/captacao">
            <Route path="home" element={<HomeCaptacao />} />
            <Route path="diarias" element={<CaptacaoDiarias />} />
            <Route path="controle" element={<ControleDeCaptacao />} />
            <Route path="solicitacoes" element={<SolicitacoesCaptacaoAvaliacao />} />
            <Route path="solicitacaoAndamento" element={<SolicitacaoAndamento />} />
          </Route>
          <Route path="/avaliacao">
            <Route path="casos" element={<CasosAvaliacao />} />
            <Route path="relatorios" element={<AvaliacaoRelatorios />} />
            <Route path="metas" element={<MetasAvaliacao />} />
            <Route path="metas/controle" element={<MetasAvaliacaoControle />} />
            <Route path="resultados" element={<AvaliacaoResultados />} />
            <Route path="solicitacoes" element={<SolicitacaoAndamentoAv />} />
            <Route path="solicitacao/form" element={<SolicitacaoesCaptacaoAvaliacao />} />
          </Route>
          <Route path="home" element={<HomeAvaliacao />} />
          <Route path="home" element={<HomeAvaliacao />} /> {/* Nova rota */}
          <Route path="juridico">
            <Route path="form" element={<JuridicoForm />} />
            <Route path="resultados" element={<JuridicoResultados />} />
            <Route path="edital" element={<EditalJuridico />} />
          </Route>
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/metas/admin" element={<MetasAdministrador />} />
          <Route path="*" element={<h2>Página não encontrada</h2>} />
        </Routes>
      </main>
      <Modal
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        className="modal"          // sua classe css para modal (ou customize aqui)
        overlayClassName="modal-overlay"
        ariaHideApp={false}       // importante para evitar warnings
      >
        <div className="modal-header">
          <h2>Perfil do Usuário</h2>
        </div>
        <div className="modal-body space-y-3 text-sm flex flex-col justify-center items-center">
          <img src={usuario.usuario_foto} alt="" className="w-20 h-20 rounded-full" />
          <div>
            <span className="font-semibold">Nome:</span> {usuario.nome}
          </div>
          <div>
            <span className="font-semibold">E-mail: </span>{usuario.email}
          </div>
          <div>
            <span className="font-semibold">Cargo:</span>{usuario.funcao}
          </div>
          <div>
          </div>

          <div className="space-y-4">
            <label className="block">
              <span className="text-gray-700">Selecionar nova foto</span>
              <input type="file" onChange={handleFileChange} className="block mt-1" />

            </label>
            
            {/* {preview ? (
              <img src={preview} alt="Preview" className="h-32 w-32 rounded-full object-cover border" />
            ) : (
              <span className="text-sm text-gray-400">Nenhuma imagem selecionada</span>
            )} */}

            
          </div>

        </div>
        <div className="modal-footer mt-4 flex gap-5 justify-end">
          <button
            className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-600"
            onClick={() => setOpen(false)}
          >
            Fechar
          </button>
           <button
              onClick={atualizarFoto}
            className="px-4 py-2 bg-black-600 text-white rounded hover:bg-gray-600"
            >
              Atualizar Foto
            </button>
        </div>
      </Modal>
      <Modal
        isOpen={isLogoutModalOpen}
        onRequestClose={closeLogoutModal}
        className="modal"
        overlayClassName="modal-overlay"
      >
        <div className="flex justify-center p-10">
          <FaExclamationCircle className="text-5xl" />
        </div>


        <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Deseja realmente sair do sistema?</h3>
        <div className="p-5 flex justify-center gap-5 mt-5">
          <button onClick={closeLogoutModal} className="cancel-button">
            Cancelar
          </button>
          <button onClick={handleLogout} className="confirm-button">
            Confirmar
          </button>

        </div>
      </Modal>
    </div>
  );
};

const SidebarLink = ({ to, label, icon, expanded, active }) => (
  <Link
    to={to}
    className={`flex ${expanded ? "justify-start" : "justify-center"} items-center gap-3 p-2 rounded transition-colors duration-200 hover:bg-gray-800 opacity-60 ${active ? "bg-gray-700 opacity-90 " : ""} `}
    title={!expanded ? label : undefined}
  >
    {icon}
    {expanded && <span className="truncate">{label}</span>}
  </Link>
);

const Submenu = ({ children, expanded }) => (
  <div className={`ml-4 border-l border-gray-600 ${expanded ? "block" : "hidden"}`}>
    <div className="flex flex-col gap-1 mt-1">{children}</div>
  </div>
);

export default App;
